// extracted by mini-css-extract-plugin
export default {"bold":"xdG_9naj46YS9T903pHE"};